import { AxiosInstance } from "axios";
import type { GoogleTaskList } from "./GoogleTasksSourceSettings.types";

export class GoogleTasksSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getLists(boardId: string, connectionId: string): Promise<GoogleTaskList[]> {
    const response = await this.client.get<GoogleTaskList[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/googletasks/lists`,
    );
    return response.data;
  }
}
